import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSellerAuth } from '../context/SellerAuthContext';

const SellerPrivateRoute = ({ children }) => {
  const { isSeller, loading } = useSellerAuth();
  const location = useLocation();

  if (loading) {
    return <div style={{ padding: '20px' }}>로딩중...</div>;
  }

  if (!isSeller) {
    return (
      <Navigate
        to="/seller/manage"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
};

export default SellerPrivateRoute;